export default __webpack_public_path__ + "static/media/nwr_Moose.8f9b35bd.png";